/**
 * Utilidades para el formulario de datos personales.
 */
const disableFutureDates = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export default disableFutureDates;
